<template>
  <b-form-select :id="safeId()" v-model="localValue" :options="options"
                 text-field="label" value-field="value">
  </b-form-select>
</template>

<script>
  export default {
    name: 'column-select',
    props: {
      'datasetId': {required: true},
      'value': {required: true}
    },
    data () {
      return {
        localValue: this.value
      }
    },
    computed: {
      options () {
        if (!this.datasetId) return [{label: '', value: null}]
        return [{label: '', value: null}].concat(this.$store.getters.datasetColumns(this.datasetId).map(column => {
          return {
            label: column,
            value: column
          }
        }))
      }
    },
    watch: {
      localValue: function (val) {
        this.$emit('input', val)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/ui/column-select.vue